import { createReducer, on } from '@ngrx/store';
import { setNotificationListPageNumber, setNotificationListItemsPerPage } from '../actions/notification.action';

export interface NotificationState {
    pageNumberNotificationList: number;
    itemsPerPageNotificationList: number;
}

export const initialState: NotificationState = {
    pageNumberNotificationList: 1,
    itemsPerPageNotificationList: 10,
};

export const notificationReducer = createReducer(
    initialState,
    on(setNotificationListPageNumber, (state, { pageNumberNotificationList }) => ({ ...state, pageNumberNotificationList })),
    on(setNotificationListItemsPerPage, (state, { itemsPerPageNotificationList }) => ({ ...state, itemsPerPageNotificationList })),
);